import { IconProps } from "interfaces/icons";

const ChartIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 24;

	if (size) {
		height = size;
	}

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={height}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color || "#0A0E27"}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<line x1="18" y1="20" x2="18" y2="10" />
			<line x1="12" y1="20" x2="12" y2="4" />
			<line x1="6" y1="20" x2="6" y2="14" />
		</svg>
	);
};

export default ChartIcon;
